import axiosInstance from './axiosInstance';

export const GetSerializedById = async (sn_id) => {
  try {
    const { data } = await axiosInstance.get(`/SnPart/Data/${sn_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSerializedBySo = async (so_id) => {
  try {
    const { data } = await axiosInstance.get(`/SnPart/So/${so_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetSerializedByParentSn = async (parent_id) => {
  try {
    const { data } = await axiosInstance.get(`/SnPart/ParentSn/${parent_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetUnAssignedSerializedByStoreCompany = async (store_id, company_id) => {
  try {
    const { data } = await axiosInstance.get(`/SnPart/UnassignedData/${store_id}/${company_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const GetUnAssignedSerializedByStoreCompanyFilter = async (store_id, company_id, filter) => {
  try {
    const { data } = await axiosInstance.get(`/SnPart/UnassignedData/${store_id}/${company_id}/${filter}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const getSerializedListByStoreCompany = async (store_id, company_id) => {
  try {
    const { data } = await axiosInstance.get(`/SnPart/Data/${store_id}/${company_id}`);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const AddSerializedApi = async (part_id, sn, mfg_sn, so_id, parent_sn_id, p_location_id, inkit_status_id, kit_id, ship_date, po_id, receive_date, slot_id, note) => {
  try {
    const { data } = await axiosInstance.post(`/SnPart`, {
      part_id: part_id,
      sn: sn,
      mfg_sn: mfg_sn,
      so_id: so_id,
      parent_sn_id: parent_sn_id,
      p_location_id: p_location_id,
      inkit_status_id: inkit_status_id,
      kit_id: kit_id,
      ship_date: ship_date,
      po_id: po_id,
      receive_date: receive_date,
      slot_id: slot_id,
      note: note,
    });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditSerializedSnApi = async (sn_id, sn, mfg_sn, note) => {
  try {
    const { data } = await axiosInstance.put(`/SnPart/Sn/${sn_id}`, { sn: sn, mfg_sn: mfg_sn, note: note });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditSerializedSoApi = async (so_id, ship_date, sn_ids) => {
  try {
    const { data } = await axiosInstance.put(`/SnPart/So`, { so_id: so_id, ship_date: ship_date, sn_ids: sn_ids });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const EditSerializedParentSnApi = async (parent_sn_id, sn_ids) => {
  try {
    const { data } = await axiosInstance.put(`/SnPart/ParentSn`, { parent_sn_id: parent_sn_id, sn_ids: sn_ids });
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};

export const DelSerialized = async (sn_id) => {
  try {
    const { data } = await axiosInstance.delete(`/Serialized/${sn_id}`);
    return data;
  } catch (err) {
    if (err.response?.data)
      return err.response.data;
    throw err;
  }
};
